<script setup>
/**
 * @description 页脚社媒二维码面板
 * @param {string} qrImage - 二维码图片路径
 * @param {string} qrText - 说明文案
 */

const props = defineProps({
  qrImage: {
    type: String,
    required: true,
  },
  qrText: {
    type: String,
    default: '',
  },
})

const { withBase } = useBasePath()
</script>

<template>
  <div class="footer-social-qr-panel">
    <img
      :src="withBase(props.qrImage)"
      :alt="props.qrText || '二维码'"
      class="footer-social-qr-panel__image"
    />
    <p v-if="props.qrText" class="footer-social-qr-panel__text">{{ props.qrText }}</p>
  </div>
</template>

<style scoped lang="scss">
.footer-social-qr-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: $spacing-xs;

  &__image {
    width: 108px;
    height: 108px;
    object-fit: contain;
  }

  &__text {
    margin: 0;
    color: $text-content-color;
    font-size: $font-size-body-3;
    line-height: $line-height-body-3;
    text-align: center;
  }
}
</style>
